import React, { useEffect, useState } from 'react';
import styled from 'styled-components';

const Block = styled.div`
  background: unset;
  transition: background 0.4s;

  &.active {
    background: yellow;
  }
`;

const DELAY = 1.5 * 1000;

export const BlockHighLight: React.FC<{ show?: boolean }> = ({ children, show = false }) => {
  const [active, setActive] = useState(false);

  // sync local state with props
  useEffect(() => {
    setActive(show);

    setTimeout(() => {
      setActive(false);
    }, DELAY);
  }, [show]);

  return <Block className={active ? 'active' : ''}>{children}</Block>;
};
